
import { Button, Card, Col, Row } from 'react-bootstrap';
import { HiRefresh } from "react-icons/hi";
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ListTransfer from '../../features/transfers/components/ListTransfer';
import { resetTransfer, listTransfer, transferState } from '../../features/transfers/transferSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import { useEffect } from 'react';
import Paginator from '../../components/Paginator/Paginator';
import { useTransfer } from '../../features/transfers/hooks/useTransfer';

const Transfers = () => {
    const [isLoading,transfers, previous, next] = useTransfer();
    const dispatch = useAppDispatch();
    const handleRefresh = () => {
        dispatch(resetTransfer());
    };
    const { deletedTransfer } = useAppSelector(transferState);

    const handlePrevious = ({ start, hadNext}: { start: string, hadNext: boolean }) => {
        if(start === 'firstPage') {
            dispatch(resetTransfer());
        } else {
            dispatch(listTransfer({ start, hadNext}));
        }
    };

    const handleNext = ({ start, hasPrevious }: { start?: string, hasPrevious: boolean }) => {
        dispatch(listTransfer({ start, hasPrevious }));
    };
    const { toastList, addToast } = useToaster();

    useEffect(() => {
        if (deletedTransfer.isSuccess) {
            addToast({ idx: 'transferDeleted', theme: 'success', title: 'Success', body: () => (<>Successfully deleted the transfer</>) });
        }        
    }, [deletedTransfer]);


    return (
        <>
            <DashboardPage heading="Transfers">
                <Card>
                    <Card.Header>
                        <Row>
                            <Col md={8} sm={7} xs={7}>
                                <Card.Title className="mb-2">Transfers</Card.Title>
                                <Card.Subtitle className="text-muted">List of all Smash Tranfers created via the Smash API</Card.Subtitle>
                            </Col>
                            <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                                <Paginator onNext={handleNext} onPrevious={handlePrevious} previous={previous} next={next} />
                                <Button variant="light" onClick={handleRefresh}><HiRefresh /> </Button>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <ListTransfer />
                    </Card.Body>
                </Card>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default Transfers